import { TimeIcon } from 'cokitchen-icons';
import { ReactComponent as PeopleIcon } from 'assets/icons/people.svg';
import './index.css';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import { ReactComponent as LoaderCircle } from 'assets/icons/loader-circle.svg';
import LocalModal from 'components/base/local-modal';
import Button from 'components/base/button';
import React from 'react';
import { useCountDown } from 'hooks/useCountdown';
import moment from 'moment';
import { BatchOrderCountType, MinimumOrderType } from 'models/order.model';
import { FCB_BATCH_ORDER_STATUS } from 'utils/enum';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  cutoffTime: string;
  isWithingOneHour: boolean;
  orderCountRes?: BatchOrderCountType;
  isOrderCountLoading: boolean;
  minOrderRes?: MinimumOrderType;
  isMinOrderLoading: boolean;
  day: string;
};
const OrderConfirmationTimelineModal = ({
  isOpen,
  onClose,
  cutoffTime,
  isWithingOneHour,
  orderCountRes,
  isOrderCountLoading,
  isMinOrderLoading,
  minOrderRes,
  day
}: Props) => {
  const date =
    day === 'Tomorrow'
      ? moment(`${moment().format('YYYY-MM-DD')} ${cutoffTime}`).add(1, 'day')
      : moment(`${moment().format('YYYY-MM-DD')} ${cutoffTime}`);
  const decodedMins = Math.abs(date.diff(moment(), 'minutes'));

  const pending =
    orderCountRes?.status === FCB_BATCH_ORDER_STATUS.ONGOING ||
    orderCountRes?.status === FCB_BATCH_ORDER_STATUS.COMPLETED;

  const { hours, minutes, seconds } = useCountDown({ minutes: decodedMins });
  const orderDetails = [
    {
      icon: <PeopleIcon className='w-4 h-4' />,
      desc: 'Required number of orders',
      amount: isMinOrderLoading ? (
        <LoaderCircle className='w-3 h-3 animate-spin text-gray-10' />
      ) : (
        minOrderRes?.minimum_orders_upper
      )
    },
    {
      icon: <TimeIcon className='text-gray-5' />,
      desc: 'Current number of orders',
      amount: isOrderCountLoading ? (
        <LoaderCircle className='w-3 h-3 animate-spin text-gray-10' />
      ) : (
        orderCountRes?.order_count ?? '0'
      )
    },
    {
      icon: <PhoneIcon />,
      desc: 'Time until order expires',
      amount: (
        <span className={`text-xs font-medium ${isWithingOneHour ? 'text-red-5' : 'text-green-5'}`}>
          {hours}hr {minutes}mins {seconds}secs
        </span>
      )
    }
  ];

  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose}>
      <div className='flex justify-center mb-4'>
        <span
          className={`inline-flex  rounded-full p-2  ${!pending ? 'bg-yellow-2' : 'bg-green-2'}`}>
          <span
            className={`rounded-full p-4 fill-white stroke-white ${
              !pending ? 'bg-yellow-5' : 'bg-green-5'
            }`}>
            <TimeIcon className='text-white w-6 h-6' />
          </span>
        </span>
      </div>
      <h2 className='text-center font-semibold text-xl'>
        Order {!pending ? 'Confirmation Pending' : 'Comfirmed'}
      </h2>
      <p className='text-sm text-gray-8 text-center max-w-xs mx-auto mt-1 font-medium'>
        {!pending
          ? '  Your order will be cofirmed once the required number of orders is complete'
          : 'Your order has been comfirmed'}
      </p>
      <ul className='my-5 space-y-2'>
        {orderDetails.map((detail) => (
          <li key={detail.desc} className='flex items-center justify-between'>
            <span className='flex items-center gap-2 text-gray-8 '>
              <span className='w-4 h-4'>{detail.icon}</span>
              {detail.desc}
            </span>
            <span>{detail.amount}</span>
          </li>
        ))}
      </ul>
      <Button className={`w-full order-confirmation-btn`} onClick={onClose}>
        Ok
      </Button>
    </LocalModal>
  );
};

export default OrderConfirmationTimelineModal;
